import React, { useEffect, useState }   from 'react';
import EditUserForm                     from '../components/modal/EditUserForm';
import axios                            from 'axios';
import { useTranslation }               from 'react-i18next';
import { 
  Container, 
  Box, 
  Avatar, 
  Typography, 
  Divider, 
  Button, 
  Skeleton
} from '@mui/material';
import ApiService from '../components/service/ApiService';


const UserProfile = () => {
  const [userData,      setUserData     ] = useState(null);
  const [openEditForm,  setOpenEditForm ] = useState(false);
  const [loading,       setLoading      ] = useState(false); 

  const {t} = useTranslation();

  const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;

    const id = user?.idCliente; //per ora così per non farlo sballare

    const headers = {
        Authorization: `Bearer ${token}`,
    };    

  useEffect(() => {
    const fetchDatiCliente = async () => {
      setLoading(true); 
      try {
        const response = await axios.get(`/cliente/${id}`, { headers: headers});
        // const response = await ApiService.request("getCliente", { id: id});
        if (response.data) {          
          setUserData(response.data);
        } else {
          console.error("I dati ottenuti non sono nel formato Array:", response.data);
        }
      } catch (error) {
        console.error("Errore nel recupero dei dati dell'utente", error);
      } finally {
        setLoading(false); 
      }
    };

    fetchDatiCliente();
  }, []);


  const handleOpenEditForm = () => {
    setOpenEditForm(true);
  };

  const handleCloseEditForm = () => {
    setOpenEditForm(false);
  };

  if (loading) {
    return (
      <Container maxWidth="false" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Box sx={{ width: '80%', mx: 'auto' }}>
          <Skeleton variant="rectangular" width={150} height={150} sx={{ borderRadius: '50%', mb: 4 }} />
          <Skeleton variant="text" width="60%" height={30} />
          <Skeleton variant="text" width="40%" height={30} />
          <Skeleton variant="rectangular" width="100%" height={50} sx={{ mt: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={50} sx={{ mt: 2 }} />
        </Box>
      </Container>
    );
  }

  
  return (
    <Container
      maxWidth="false"
      sx={{
        display: 'flex',
        backgroundColor: '#F8F8F8',
        flex: 1,
        width: '100vw',
        justifyContent: 'center',
        alignItems: 'stretch',
        padding: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          backgroundColor: 'transparent',
          minHeight: '86%',
          width: '100%',
          flexDirection: 'row',
          mx: 5
        }}
      >
        {/* Barra laterale user */}
        <Box
          sx={{
            background: `linear-gradient(135deg, #28334B, #263F78)`, 
            minWidth: {md:'25%' , lg:'15%'},
            minHeight: '86%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            borderRadius: '10px 0px 0px 10px',
            p: 3,
            pt: 5,
          }}
        >
        <Avatar sx={{ background: '#fda03d', width: 80, height: 80, marginBottom: 2, fontSize: '2rem', fontWeight: 'bold' }}>
          {user?.nome?.[0]?.toUpperCase()}{user?.cognome?.[0]?.toUpperCase()}
        </Avatar>

          <Box sx={{ width: '100%', marginTop: 2, color: '#fff' }}>
            <Box sx={{ my: 3 }}>
              <Typography variant="subtitle1" sx={{ color: '#fda03d', fontWeight: 'bold' }}>{t('Username')}</Typography>
              <Typography variant="body1">{user.username}</Typography>
            </Box>
            <Box sx={{ my: 3 }}>
              <Typography variant="subtitle1" sx={{ marginTop: 1, color: '#fda03d', fontWeight: 'bold' }}>{t('Cellulare')}</Typography>
              <Typography variant="body1">{userData?.telefono}</Typography>
            </Box>
            <Box sx={{ my: 3 }}>
              <Typography variant="subtitle1" sx={{ marginTop: 1, color: '#fda03d', fontWeight: 'bold' }}>{t('Lingua')}</Typography>
              <Typography variant="body1">{user.lingua}</Typography>
            </Box>
          </Box>
        </Box>

        {/* Contenuto dati user */}
        <Box
          sx={{
            width: '100%',
            backgroundColor: '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            borderRadius: '0px 10px 10px 0px',
            borderLeft: 'none',
            p: 6,
            position: 'relative',
          }}
        >
        <Typography component="div" sx={{ fontSize: 30, fontWeight: 'bold' }}>
          {`${user?.nome?.charAt(0).toUpperCase() || ''}${user?.nome?.slice(1).toLowerCase() || ''} ${user?.cognome?.charAt(0).toUpperCase() || ''}${user?.cognome?.slice(1).toLowerCase() || ''}`}
        </Typography>


          <Divider sx={{ width: '25%', marginY: 2, border: 'solid 1px #fda03d' }} />

          <Box sx={{ marginTop: 2 }}>
            <Box sx={{ my: 3 }}>
              <Typography variant="subtitle1" sx={{ marginTop: 1, color: '#213d72', fontWeight: 'bold' }}>{t('Partita iva')}</Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'grey'}}>{userData?.piva}</Typography>
            </Box>
            <Box sx={{ my: 3 }}>
              <Typography variant="subtitle1" sx={{ marginTop: 1, color: '#213d72', fontWeight: 'bold' }}>{t('Ragione sociale')}</Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'grey'}}>{userData?.ragioneSociale}</Typography>
            </Box>
            <Box sx={{ my: 3 }}>
              <Typography variant="subtitle1" sx={{ marginTop: 1, color: '#213d72', fontWeight: 'bold' }}>{t('Persona di contatto')}</Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'grey'}}>{userData?.personaContatto}</Typography>
            </Box>
            <Box sx={{ my: 3 }}>
              <Typography variant="subtitle1" sx={{ marginTop: 1, color: '#213d72', fontWeight: 'bold' }}>{t('Email persona di contatto')}</Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'grey'}}>{userData?.emailPersonaContatto}</Typography>
            </Box>
            <Box sx={{ my: 3 }}>
            <Typography variant="subtitle1" sx={{ marginTop: 1, color: '#213d72', fontWeight: 'bold' }}>{t('Commerciale di riferimento')}</Typography>
            <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'grey'}}>  {userData?.commerciale?.nome} {userData?.commerciale?.cognome}</Typography>
            </Box>
          </Box>
          {/* <Button
            variant="contained"
            sx={{ backgroundColor: '#fda03d', color: '#fff', alignSelf: 'center', mt: 'auto', mb: 2, fontWeight: 'bold' }}
            onClick={handleOpenEditForm}
          >
            {t('Modifica utente')}
          </Button> */}
        </Box>
      </Box>

      {/* Popup di modifica utente */}
      {openEditForm && (
        <EditUserForm
          userData={userData}
          onClose={handleCloseEditForm}
        />
      )}
    </Container>
  );
};

export default UserProfile;
